import React, { useState } from "react";
import "./displayUploadedFiles.scss";
import moment from "moment";
import info_icon from "../../../assets/dashboard/info_icon.svg";
import Popover from "react-popover";
import Axios from "axios";
import { GetApp, Reply, Visibility } from "@material-ui/icons";
import useIsMobile from "../../../Util/Helper/useIsMobile";

const DisplayUploadedFiles = (props) => {
  const {
    data,
    fileName,
    fileType,
    fileSize,
    downloadUrl,
    uploadedBy,
    fileDateTime,
    viewDocument,
    shareRxErx,
  } = props;

  const [isOpen, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const isMobile = useIsMobile();

  // Actions ==>

  const handlePopoverOpen = (event) => {
    setOpen(true);
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setOpen(false);
    setAnchorEl(null);
  };

  const downloadURI = async () => {
    const blob = await Axios.get(downloadUrl, {
      headers: {
        "Content-Type": "application/octet-stream",
      },
      responseType: "blob",
    });
    const a = document.createElement("a");
    const href = window.URL.createObjectURL(blob.data);
    a.href = href;
    a.download = fileName + "." + fileType.trim();

    a.click();
  };

  // <===

  // Display UI ===>

  const displayHoverContent = () => {
    return (
      <div style={{ padding: "6px 10px", fontSize: "12px" }}>{uploadedBy}</div>
    );
  };

  const displayFiles = () => {
    let enableView =
      fileType?.toLowerCase().includes("pdf") ||
      fileType?.toLowerCase().includes("jpg") ||
      fileType?.toLowerCase().includes("png") ||
      fileType?.toLowerCase().includes("jpeg");

    return (
      <div className="display-uploaded-files-cont">
        <div className="display-uploaded-files">
          <div
            className={
              "display-uploaded-files-details " +
              (shareRxErx
                ? "file-details-with-share-erx"
                : "file-details-without-share-erx")
            }
          >
            <div className="d-flex ai-center w-100">
              <div className="uploaded-filename">{fileName}</div>
              {uploadedBy && (
                <Popover
                  isOpen={isOpen}
                  preferPlace={`below`}
                  place={null}
                  anchorEl={anchorEl}
                  body={displayHoverContent()}
                >
                  <img
                    src={info_icon}
                    alt=""
                    style={{ cursor: "pointer", marginLeft: "6px" }}
                    onMouseOver={handlePopoverOpen}
                    onMouseOut={handlePopoverClose}
                  />
                </Popover>
              )}
            </div>
            <div className="uploaded-file-details">
              {moment(fileDateTime).format("DD MMM, YYYY | hh:mm A")}
              {data?.category && !isMobile ? (
                <div className="uploaded-file-details-category">
                  {data?.category}
                </div>
              ) : (
                ""
              )}
            </div>
            {(fileType || fileSize) && (
              <div className="uploaded-file-type-size-details">
                <span>{fileType}</span>
                {fileSize && (
                  <>
                    <span style={{ margin: "0 2px" }}>&bull;</span>
                    <span>{fileSize}</span>
                  </>
                )}
              </div>
            )}
          </div>
          <div className="display-uploaded-files-icons">
            <span data-tooltip="View" data-tooltip-conf="bottom">
              <i
                className={
                  enableView && downloadUrl
                    ? "uploaded-file-icons"
                    : "uploaded-file-disable-icon"
                }
                onClick={() => enableView && viewDocument(data)}
              >
                <Visibility fontSize="small" />
              </i>
            </span>
            <span data-tooltip="Download" data-tooltip-conf="bottom">
              {" "}
              <i
                className={
                  downloadUrl
                    ? "uploaded-file-icons"
                    : "uploaded-file-disable-icon"
                }
                onClick={downloadURI}
              >
                <GetApp fontSize="small" />
              </i>
            </span>
            {shareRxErx && (
              <span data-tooltip="Share" data-tooltip-conf="bottom">
                <i
                  className={
                    downloadUrl
                      ? "uploaded-file-icons"
                      : "uploaded-file-disable-icon"
                  }
                  onClick={() => {
                    shareRxErx(data);
                  }}
                >
                  <Reply
                    fontSize="small"
                    style={{
                      transform: "scaleX(-1)",
                    }}
                  />
                </i>
              </span>
            )}
          </div>
        </div>
        {data?.category && isMobile ? (
          <div className="uploaded-file-details-category">{data?.category}</div>
        ) : (
          ""
        )}
      </div>
    );
  };

  // <===

  return <>{displayFiles()}</>;
};

export default DisplayUploadedFiles;
